module.exports = __webpack_public_path__ + "static/media/cncdatabase_logo_v2.95ba0cbf.png";